export default "__VITE_ASSET__l9hgdVPa__"